module.exports = __webpack_public_path__ + "img/book.e2af190d.svg";